import { render, staticRenderFns } from "./Addition.vue?vue&type=template&id=0be829a6&"
import script from "./Addition.vue?vue&type=script&lang=js&"
export * from "./Addition.vue?vue&type=script&lang=js&"
import style0 from "./Addition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports